import { AvistaHero } from "../../components/avista/home/AvistaHero";

export function AvistaHomePage () {
  return (
    <>
    <AvistaHero />
    </>
  )
}